import React from 'react';
import styles from './PrivacyPolicy.module.scss';
import Section from "./Section";
import {Subsection} from "./AboutUs";
import {stTERMS} from "./NavBar";

const TermsAndConditions: React.FC = () => {
    return (
        <Section id={stTERMS}>
            <h1>Terms and Conditions</h1>
            <p>Welcome to EquiQuill! These Terms and Conditions govern your use of the EquiQuill App, an application
                designed for entertainment and support for various mental health conditions, currently in alpha and beta
                testing phases.</p>
            <Subsection>

                <h2>Acceptance of Terms and Privacy</h2>
                <p>By using the EquiQuill App, you agree to these Terms and our Privacy Policy (<a
                    href="https://www.equiquill.com/privacy">https://www.equiquill.com/privacy</a>), which details our
                    data
                    collection practices, including the collection of email, name, and connectivity elements.</p>
            </Subsection>

            <Subsection>
                <h2>Service Description and User Conduct</h2>
                <p>EquiQuill, detailed at <a href="https://www.equiquill.com/#aboutus">https://app.equiquill.com/about</a>,
                    is
                    in its alpha stage of development. While it offers support for mental health conditions, it is not a
                    substitute for professional care. Users are expected to use the app responsibly and not for any
                    unlawful
                    purpose.</p>
            </Subsection>
            <Subsection>

                <h2>Intellectual Property and Limitations of Liability</h2>
                <p>All rights, trademarks, and copyrights in the app are owned by or licensed to EquiQuill. The app is
                    provided 'as is' without any guarantees, and we are not liable for errors, damages, or service
                    interruptions.</p>
            </Subsection>
        </Section>


    );
};

export default TermsAndConditions;